export interface ILoginState {
    showModal: boolean;
    modalData: string;
    modalHeaderData: string;
    isAnnouncementContentModalOpen: boolean;
    isLoading: boolean;
}

export interface ILoginInformation {
    trackingGuid: string;
    organizationId: number;
    organizationName: string;
    headerText: string;
    footerText: string;
    logoPath: string;
    backgroundPath: string;
    backgroundColor: string;
}

export interface ILoginProps {
    currentPage: string;
    isResetPassword?: string;
    username: string;
    pageData?: ILoginPageData;
    location: any;
    dispatch: any;
    announcementData: ILoginAnnouncementModel[] | null | undefined;
    organizationId: string;
    culture: string;
    loginAnnouncementError?: boolean;
}

export interface IModLoginState {
    currentPage: string;
    pageData: ILoginPageData;
}

export interface ILoginFormState {
    textInput: string;
}

export interface ILoginFormProps {
    username?: any;
    headerText?: any;
    forgotMyPassword?: any;
    forgotPasswordEnable?: any;
    requiresQuestionAndAnswer?: any;
    forgotPasswordURLLink?: any;
    forgotPasswordUrlRecover?: string;
    dispatch?: any;
    isLogin?: boolean;
    loginCulture?: string;
    userType?: UserType | null;
    isAlmsPlusLogin?: boolean;
    googleCaptchaSiteKey?: string;
    isThereTwoFactorAuth?: boolean
}

export interface ILoginAfterState {
    textInput: string;
    redirectPage: string;
}

export interface ILoginAfterProps {
    username?: string;
    headerText?: string;
    isLogin?: boolean;
    dispatch?: any;
    loginCulture?: string;
    onBackClick(): void;
}

export interface IExternalLoginProps {
    isLogin?: boolean;
    dispatch?: any;
    history: any;
    userType?: UserType | null;
    isThereTwoFactorAuth?: string;
}

export interface IExternalLoginObsProps {
    isLogin?: boolean;
    dispatch?: any;
    history: any;
    userType?: UserType | null;
}
export interface IEdevletLoginProps {
    isLogin?: boolean;
    dispatch?: any;
    userType?: UserType | null;
}

export interface IResetPasswordState {
    empty: string;
}

export interface IResetPasswordProps {
    haveUser?: boolean;
    passwordSecurtiyQuestion?: string;
    isQuestion?: string;
    currentPage?: string;
    resetPasswordLoading?: boolean;
    dispatch?: any;
    organizationId?: any;
}

export interface INewPassword {
    notFoundToken?: boolean;
    expiredToken?: boolean;
    currentPage?: string;
    newPasswordLoading?: boolean;
    minPasswordNumericCharacter?: number;
    recoveryPasswordToken?: string;
    // minPasswordCharacter:number;
    passwordDifficultyComment?: string;
    username?: string;
    alphaNumericLength?: number;
    minPasswordLength?: number;
    passwordStrength?: string;
    newPasswordSaveStatus?: boolean;
    dispatch?: any;
}

export interface ISendVerifyMail {
    dispatch?: any;
    currentPage?: string;
}

export interface IMyForgotPasswordQuestion {
    passwordSecurtiyQuestion?: string;
    isQuestion?: string;
    currentPage?: string;
    answerStatus?: boolean;
    username?: string;
    myForgotPasswordAnswerStatus?: boolean;
    myForgotPasswordQuestionLoading?: boolean;
    dispatch?: any;
}

export interface ILoginAnnouncement {
    subject: string;
    body: string;
    enddate: string;
    startdate: string;
}
export interface ILoginAnnouncementState {
    loginannouncement: ILoginAnnouncement[];
}
export interface ILoginAnnouncementProps {
    onAnnouncementClick(e: any): void;
}
export interface IPopupProps {
    handleData: string;
    handleModalCloseClick(): void;
}

export interface ILoginPageData {
    trackingGuid: string;
    organizationId: number;
    organizationName: string;
    abbreviation: string;
    headerText: string;
    footerText: string;
    logoPath: string;
    backgroundPath: string;
    organizationLogo: string;
    backgroundColor: string;
    forgotMyPassword: any;
    forgotPasswordEnable: any;
    requiresQuestionAndAnswer: any;
    forgotPasswordURLLink: any;
    forgotPasswordUrlRecover: string;
    headerBackgroundImage: any;
    requisiteMinPasswordLength: any;
    minNonAlphanumericLength: any,
    forceChangePassword: any,
    isAlmsPlusLoginPage: boolean | null,
    googleCaptchaSiteKey?: string;
    isThereTwoFactorAuth?: boolean;
}

export interface IUserIdentity {
    firstName: string;
    lastName: string;
    fullName: string;
    email: string;
    timeZone: any;
    userName: string;
    userType: UserType;
    loginPermission: IUserPermission[];
    isSimulate?: boolean;
    customLoginPermission: IUserCustomPersmission[];
    forceChangePassword: boolean;
}

export interface IUserCustomPersmission {
    SecurityPermission: number;
    Granted: boolean;
}

export interface IUserPermission {
    encryptUserId: string;
    Role: number;
    ContextId: number;
    ContextType: number;
    OtherContextId: number;
}


export enum UserType {
    none = 0,
    User = 1,
    Admin = 2,
    SuperTeacher = 3,
    Teacher = 4,
    Student = 8,
    Parent = 16,
    ProgramAdmin = 32,
    ProgramUser = 64,
    Guest = 128,
    SuperAdmin = 264,
    GroupUser = 512
}

export interface ILoginResultData {
    isLogin: boolean;
    isError: boolean;
    errorMessage: string;
    firstName: string;
    lastName: string;
    fullName: string;
    email: string;
    userName: string;
    userType: UserType;
    loginPermission: IUserPermission[];
    customLoginPermission: IUserCustomPersmission[];
    userId: string;
    isSimulate?: boolean;
    profileImagePath: string;
    culture: string;
    clusterType?: string;
    organizationId?: string;
    timeZone?: any;
    forceChangePassword: boolean;
    programName: string;
}

export interface ILoginFormSagaModel {
    userName: string;
    password: string;
}